import React, { useState, useContext } from "react";
import { NavLink } from "react-router-dom";
import { FiMail, FiUserPlus, FiUsers, FiMenu, FiX } from "react-icons/fi";
import AuthContext from "../../contexts/AuthContext";
import "./sidebar.css";

const Sidebar = () => {
  const { role } = useContext(AuthContext);

  // Only matters on small screens (see the media query in sidebar.css) — the
  // sidebar is always visible on desktop regardless of this state.
  const [isOpen, setIsOpen] = useState(false);

  const closeOnMobile = () => setIsOpen(false);

  return (
    <>
      <button
        type="button"
        className="sidebar-toggle"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label={isOpen ? "Close menu" : "Open menu"}
      >
        {isOpen ? <FiX size={22} /> : <FiMenu size={22} />}
      </button>

      {isOpen && (
        <div className="sidebar-backdrop" onClick={closeOnMobile} aria-hidden="true" />
      )}

      <aside className={`sidebar ${isOpen ? "is-open" : ""}`}>
        <NavLink
          to="/new-contact-enquiries"
          onClick={closeOnMobile}
          className={({ isActive }) =>
            isActive ? "sidebar-card active" : "sidebar-card"
          }
        >
          <span className="sidebar-card-icon">
            <FiUserPlus size={18} />
          </span>
          <span className="sidebar-card-text">
            <h6>New Contact Enquiries</h6>
            <p className="subtitle">View & manage new enquiries</p>
          </span>
        </NavLink>

        {role === "Super Admin" && (
          <NavLink
            to="/kmw-employees"
            onClick={closeOnMobile}
            className={({ isActive }) =>
              isActive ? "sidebar-card active" : "sidebar-card"
            }
          >
            <span className="sidebar-card-icon">
              <FiUsers size={18} />
            </span>
            <span className="sidebar-card-text">
              <h6>KMW Employees</h6>
              <p className="subtitle">Manage employee records</p>
            </span>
          </NavLink>
        )}

        <NavLink
          to="/contact-us-details"
          onClick={closeOnMobile}
          className={({ isActive }) =>
            isActive ? "sidebar-card active" : "sidebar-card"
          }
        >
          <span className="sidebar-card-icon">
            <FiMail size={18} />
          </span>
          <span className="sidebar-card-text">
            <h6>Contact Us</h6>
            <p className="subtitle">View & manage Old enquiries</p>
          </span>
        </NavLink>

        {/* <NavLink
          to="/seo-enquiry-details"
          className={({ isActive }) =>
            isActive ? "sidebar-card active" : "sidebar-card"
          }
        >
          <h6>SEO Enquiries</h6>
          <p className="subtitle">SEO leads & enquiries</p>
        </NavLink> */}
      </aside>
    </>
  );
};

export default Sidebar;
